import { WebsiteHeaderPhotoSchema_PhotoTrioPageWidth_v1_1_1 } from '@apps/guest/websiteHeader';

export const PHOTO_TRIO_PAGE_WIDTH_v1_1_1: WebsiteHeaderPhotoSchema_PhotoTrioPageWidth_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrioPageWidth-v1_1_1.json',
  presentationLayout: 'photoTrioPageWidth',
  photos: [],
};
